module.exports = __webpack_public_path__ + "img/44.3.TP.22d10ee6.png";